import { render, staticRenderFns } from "./CityHospitalShort.vue?vue&type=template&id=4d3388a4&"
import script from "./CityHospitalShort.vue?vue&type=script&lang=js&"
export * from "./CityHospitalShort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports